import React from 'react';
import { Breadcrumb } from 'antd';
import { useLocation, Link } from 'react-router-dom';
import {
  DashboardOutlined,
  ApiOutlined,
  FileTextOutlined,
  DatabaseOutlined,
  SettingOutlined,
  UserOutlined
} from '@ant-design/icons';

const BreadcrumbNav: React.FC = () => {
  const location = useLocation();

  type BreadcrumbItemType = {
    title: React.ReactNode;
    key: string;
    href?: string;
  };

  const getBreadcrumbItems = () => {
    const pathSnippets = location.pathname.split('/').filter(i => i);
    const items: BreadcrumbItemType[] = [
      {
        title: (
          <span>
            <DashboardOutlined />
            <span style={{ marginLeft: 4 }}>Dashboard</span>
          </span>
        ),
        key: 'home',
        href: '/',
      },
    ];

    if (pathSnippets.length === 0) {
      return items;
    }

    const iconMap: { [key: string]: React.ReactNode } = {
      devices: <ApiOutlined />,
      tcp: <ApiOutlined />,
      mqtt: <ApiOutlined />,
      'audit-logs': <FileTextOutlined />,
      redis: <DatabaseOutlined />,
      settings: <SettingOutlined />,
      system: <SettingOutlined />,
      users: <UserOutlined />,
    };

    const nameMap: { [key: string]: string } = {
      devices: 'Devices',
      tcp: 'TCP',
      mqtt: 'MQTT',
      'audit-logs': 'Audit Logs',
      redis: 'Redis Management',
      settings: 'Settings',
      system: 'System Settings',
      users: 'User Management',
    };

    let url = '';
    pathSnippets.forEach((snippet, index) => {
      url += `/${snippet}`;
      const isLast = index === pathSnippets.length - 1;

      if (!isLast) {
      items.push({
        title: (
          <span>
            {iconMap[snippet] && <span style={{ marginRight: 4 }}>{iconMap[snippet]}</span>}
            {nameMap[snippet] || snippet}
          </span>
        ),
        key: snippet,
        href: url || '',
      });
    } else {
      items.push({
        title: (
          <span>
            {iconMap[snippet] && <span style={{ marginRight: 4 }}>{iconMap[snippet]}</span>}
            {nameMap[snippet] || snippet}
          </span>
        ),
        key: snippet,
      });
    }
    });

    // Convert href to Link component for React Router
    return items.map((item, index) => {
      const hasHref = 'href' in item && item.href !== undefined;
      return {
        ...item,
        title: hasHref && index < items.length - 1 ? (
          <Link to={item.href as string} style={{ color: '#6366f1' }}>
            {item.title}
          </Link>
        ) : (
          item.title
        ),
      };
    });
  };

  return (
    <Breadcrumb
      style={{ marginBottom: 16 }}
      items={getBreadcrumbItems()}
      separator=">"
    />
  );
};

export default BreadcrumbNav;